import { Button } from "@/components/ui/button";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export function NotFoundPage() {
  useDocumentTitle("Page not found");
  return (
    <div className="flex min-h-screen flex-1 flex-col items-center justify-center p-6">
      <div className="w-full max-w-md flex flex-col items-center gap-4 text-center">
        <h1 className="text-6xl font-bold tracking-tight text-muted-foreground">404</h1>
        <p className="text-lg text-muted-foreground">
          This page doesn't exist.
        </p>
        <Button asChild variant="outline">
          <a href="/">Go home</a>
        </Button>
      </div>
    </div>
  );
}
